export default "__VITE_ASSET__DFL04DZL__"